import { Card as MuiCard, CardContent, CardHeader } from '@mui/material';
import type { CardHeaderProps } from '@mui/material/CardHeader';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';


const cardStyles = makeStyles(() =>
    createStyles({
        'card-header-action': {
            alignSelf: 'unset !important'
        },
    })
);

// 卡片
export default function Card(props: {
    // 卡片标题
    title?: string | JSX.Element;
    // 按钮
    actionRender?: JSX.Element;
    // 内容
    contentRender?: JSX.Element;
    contentClassName?: string;
    className?: string;
    titleTypographyProps?: CardHeaderProps['titleTypographyProps'];
}) {
    const styles = cardStyles();
    const { title, actionRender, contentRender, contentClassName, className, titleTypographyProps } = props;
    return (
        <MuiCard className={className} elevation={2}>
            {
                title &&
                <CardHeader
                    action={actionRender}
                    title={title}
                    titleTypographyProps={titleTypographyProps}
                    classes={{ action: styles['card-header-action'] }}
                />
            }
            <CardContent className={contentClassName ?? ''}>
                {contentRender}
            </CardContent>

        </MuiCard>
    )
}